import axios from 'axios';
import http from 'core/services/http';
import Config from 'core/config';

class TcEventService {
  static getTcEvent(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}`);
  }

  static getLocations(testCenterCycleId) {
    return http.get(
      `${Config.apiUrl}/testcentercycle/${testCenterCycleId}/locations`
    );
  }

  static getRooms(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/room`);
  }

  static getTestCenterCycle(eventId) {
    return http.get(
      `${Config.apiUrl}/testcenterevent/${eventId}/testcentercycle`
    );
  }

  static getEventsById(eventIds) {
    return axios.all(
      eventIds.map((id) => http.get(`${Config.apiUrl}/testcenterevent/${id}`))
    );
  }

  static getTcsById(ids) {
    return axios.all(ids.map((id) => TcEventService.getTestCenterCycle(id)));
  }

  static deleteRoom(roomId) {
    return http.delete(`${Config.apiUrl}/room/${roomId}`);
  }

  static setRoomManualTimer(data) {
    return http.post(`${Config.apiUrl}/room/activatemanualtimer`, data);
  }

  static getRoomsDTO(eventId) {
    return http.get(
      `${Config.apiUrl}/testcenterevent/${eventId}/roomminimaldto`
    );
  }

  static getAllRoomsDTO(eventId) {
    return http.get(
      `${Config.apiUrl}/testcenterevent/${eventId}/roomminimaldto?allrooms=true`
    );
  }

  static getTCInfo(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/testcenter`);
  }

  static getDevicesCheckCount(eventId) {
    return http.get(
      `${Config.apiUrl}/testcenterevent/${eventId}/devicecheckcount`
    );
  }

  static getTcEventRoomsReviewStatus(eventId) {
    return http.get(
      `${Config.apiUrl}/query/testcentereventRoomReviewStatus?testCenterEventId=${eventId}`
    );
  }

  static getTcEventExamineesSummary(eventId) {
    return http.get(
      `${Config.apiUrl}/query/testcentereventTestedStatusSummary?testCenterEventId=${eventId}`
    );
  }

  static getTcEventExamineesStatus(eventId, status) {
    return http.get(
      `${Config.apiUrl}/query/testcentereventTestedStatusReg?testCenterEventId=${eventId}&testedStatus=${status}`
    );
  }

  static reviewEventCheckout(eventId) {
    console.debug("in review Checkout",eventId);
    const eventIdCopy = { ...eventId };
    eventIdCopy.testingEvent.adminId.cycleId.startDate += 'T00:00:00';
    eventIdCopy.testingEvent.adminId.cycleId.endDate += 'T00:00:00';
    return http.put(
      `${Config.apiUrl}/testcenterevent/${eventIdCopy.id}/reviewComplete`,eventIdCopy);
  }

  static getTcEventMaterialSummary(eventId) {
    return http.get(
      `${Config.apiUrl}/query/testCenterEventMaterialSummary?testCenterEventId=${eventId}`
    );
  }

  static getTcEventAnswerDocs(eventId) {
    return http.get(
      `${Config.apiUrl}/query/testCenterEventAnswerDocs?testCenterEventId=${eventId}`
    );
  }

  static getUnityDownloadLink(eventId) {
    return http.get(
      `${Config.apiUrl}/testcenterevent/${eventId}/unityDownloadUrl`
    );
  }

  static unassignStudents(data) {
    const apiNowUrl = Config.apiUrl.slice(0, -4) + '/now';
    return http.put(`${apiNowUrl}/reg/assign`, data);
  }
}

export default TcEventService;
